/**
 * 线上环境
 */
// export const ONLINEHOST = 'https://xmzj.emof.cn'
export const ONLINEHOST = window.location.origin;

/**
 * 测试环境
 */
export const QAHOST = "https://xmzj.emof.cn";
// export const QAHOST = "http://192.168.1.55:8170";

export const baseURL =
  process.env.NODE_ENV === "production" ? ONLINEHOST : QAHOST;

// 文件地址
export const filePath = "http://qiniu.bjyl.org.cn/"; // 七牛云上传拼接
export const urlStr = "https://zjzk.emof.cn"; // 服务器上传拼接

//文件地址
export const IMAGE_PATH = baseURL.replace("index.php/", "");

//客服电话
export const service_phone = "400-999-6541";

// 文件上传地址
// export const fileUpUrl = baseURL + '/api/index/uploadfile' // 服务器上传
export const fileUpUrl = baseURL + "/upload";

/*
 * CKEditor编辑器配置
 * */
export const ckEditConfig = () => {
  return {};
};

/*
 * 缓存字段
 * */
export const localAnStore = [
  {
    key: "shzztoken",
    type: "localStorage",
  },
  {
    key: "shzzuser",
    type: "localStorage",
  },
  {
    key: "admintoken",
    type: "localStorage",
  },
  {
    key: "adminuser",
    type: "localStorage",
  },
];
